import { useMemo } from 'react';
import { Dialog, DialogTitle, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useGetPersonalFields } from '../../../../hooks/Marketing';
import BatPreviewForm from './creation/bat/BatPreviewForm';
import { detectUsedAnchors } from './creation/bat/personalAnchors';

interface BatPreviewDialogProps {
  open: boolean;
  onClose: () => void;
  content: { html: string; subject: string } | null;
  channel?: 'EMAIL' | 'SMS';
}

function BatPreviewDialog({ open, onClose, content, channel = 'EMAIL' }: BatPreviewDialogProps) {
  const { data: personalFieldCategories } = useGetPersonalFields(channel === 'SMS' ? 'SMS' : 'EMAILING');

  const usedAnchors = useMemo(() => {
    if (!content) return [];
    const availableAnchors = new Set(Object.values(personalFieldCategories).flat().map(field => field.ANCHOR));
    return detectUsedAnchors(content.html, availableAnchors);
  }, [content, personalFieldCategories]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 2.5 } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.75, px: 3 }}>
        <Typography variant="subtitle1" fontWeight={600} sx={{ fontSize: '0.95rem' }}>
          Renseigner le nom du/des destinataire(s)
        </Typography>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      {content && (
        <BatPreviewForm
          channel={channel}
          html={content.html}
          initialSubject={content.subject}
          usedAnchors={usedAnchors}
          onSent={onClose}
        />
      )}
    </Dialog>
  );
}

export default BatPreviewDialog;
